$(function () {

    var $mod = $('.module-pannel-menu');
    //关于
    var navs = $mod.find('.attention-nav.action .cell');
    var tabContents = $('.module-global-tab');

    /*navs.on('click', function () {

        var _self = $(this);
        navs.removeClass('cur');
        _self.addClass('cur');

        tabContents.removeClass('cur');
        tabContents.eq(_self.index()).addClass('cur');

        // 资讯和直播 哎。。
        if (_self.index() === 1) {
            $mod.find('.article-count').show();

        } else {
            $mod.find('.article-count').hide();

        }
        if (_self.index() === 2) {
            $mod.find('.live-count').show();
        } else {
            $mod.find('.live-count').hide();
        }
        if (_self.index() === 6) {
            $mod.find('.design-count').show();
        } else {
            $mod.find('.design-count').hide();
        }
        if (_self.index() === 7) {
            $mod.find('.zhuangxiu-count').show();
        } else {
            $mod.find('.zhuangxiu-count').hide();
        }

        if (_self.index() === 8) {
            $mod.find('.staff-count').show();
        } else {
            $mod.find('.staff-count').hide();
        }
    });*/
    var index = window.location.href.lastIndexOf('/');
    if (document.domain == '127.0.0.1') {
        var param = window.location.href.substr(index+9);//test和本地不一致
    }else {
        var param = window.location.href.substr(index+1);//test和本地不一致
    }

    navs.each(function(){
        if ($(this).hasClass(param)) {

            $(this).addClass('cur');
        }
    })
    /*if (param == 'zixun') {
        $('.article-count').addClass('cur');
    }else {
        if (param == 'zhibo') {
            $('.live-count').addClass('cur');
        }else {
            if (param == 'sheji') {
                $('.design-count').addClass('cur');
            }else {
                if (param == 'zhuangxiu') {
                    $('.zhuangxiu-count').addClass('cur');
                }else {
                    if (param == 'shejishi' || param == 'gongzhang') {
                        $('.staff-count').addClass('cur');
                    }
                }
            }
        }
    }*/
    /*navs.on('click', function () {

        var _self = $(this);
        navs.removeClass('cur');
        _self.addClass('cur');

        tabContents.removeClass('cur');
        tabContents.eq(_self.index()).addClass('cur');
        var param = $(this).attr('class').split(' ')[0];
        var domain = document.domain;
        if (domain == '127.0.0.1') {
            window.location.href = '/page-pc-'+param;//本地和测试不同，需要改
        }else {
            window.location.href = window.location.href +'/'+param
        }
    });*/


});



// WEBPACK FOOTER //
// ./src/module/pannel-menu/pannel-menu.js